export default __webpack_public_path__ + "static/media/portfolio.e7544d6c.PNG";